export const plugins = [{
    plugin: require('bernie-plugin-isomorphic-logger/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-mobx/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-apollo/dist/browser'),
    options: JSON.parse('{"serverTimeout":5000,"browserTimeout":15000,"usePossibleTypes":true}')
  },{
    plugin: require('bernie-plugin-global-components-context/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-context/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-clickstream/dist/browser'),
    options: JSON.parse('{"brandClickstream":"uis-prime"}')
  },{
    plugin: require('bernie-plugin-ads-loader-script/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-webpack/dist/browser'),
    options: JSON.parse('{"overrides":{"client":{"optimization":{"splitChunks":{"cacheGroups":{"SharedUiProviders":{"enforce":true,"minChunks":2,"name":"shared-ui-providers","priority":100,"test":{}},"TravelersField":{"name":"shared~TravelersField","priority":100,"reuseExistingChunk":true,"test":{}},"BlossomComponents":{"minChunks":2,"minSize":6000,"priority":100,"reuseExistingChunk":true,"test":{}},"UitkExperimentalMap":{"enforce":true,"name":"uitk-experimental-map","priority":100,"test":{}},"UitkTypeahead":{"enforce":true,"name":"uitk-typeahead","priority":100,"test":{}},"EGMaps":{"enforce":true,"name":"eg-maps","priority":100,"test":{}}}}}}}}')
  }]